module.exports = function() {
  return new Worker(__webpack_public_path__ + "bfffb887c6eaea5fbf4d.worker.js");
};